export default __webpack_public_path__ + "static/media/credit-card.92c2c2e8.svg";